export const BAR_COLOR = "#6194AA";
export const BAR_HIGHLIGHT_COLOR = "#315466";
